const WEB = 'web';
const MOBILE = 'mobile';
const PLATFORMS = [WEB, MOBILE] as const;

// Define a type for the platforms
type Platform = (typeof PLATFORMS)[number];

export { PLATFORMS, WEB, MOBILE, Platform };
